import { render, staticRenderFns } from "./TransactionDetail2.vue?vue&type=template&id=fd72f190"
import script from "./TransactionDetail2.vue?vue&type=script&lang=js"
export * from "./TransactionDetail2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports